<template>
  <a-upload
    name="file"
    list-type="picture-card"
    class="avatar-uploader"
    :show-upload-list="false"
    action="/merchant.php/upload_file/uploadFile?type=ATTRIBUTE"
    :before-upload="beforeUpload"
    @change="handleChange"
  >
    <img
      v-if="imageUrl"
      :src="imageUrl"
    />
    <div v-else>
      <a-icon :type="loading ? 'loading' : 'plus'" />
      <div class="ant-upload-text">
        上传
      </div>
    </div>
  </a-upload>
</template>

<script>
function getBase64(img, callback) {
  const reader = new FileReader()
  reader.addEventListener('load', () => callback(reader.result))
  reader.readAsDataURL(img)
}

export default {
  data() {
    return {
      loading: false,
      imageUrl: this.value
    }
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    onlyBmp: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    value(val) {
      this.imageUrl = val
    }
  },
  methods: {
    // 上传图片
    handleChange(info) {
      if (info.file.status === 'uploading') {
        this.loading = true
        return
      }
      if (info.file.status === 'done') {
        // Get this url from response in real world.
        getBase64(info.file.originFileObj, (imageUrl) => {
          this.imageUrl = imageUrl
          this.loading = false
        })
        const res = info.file.response
        if (res.code === 200) {
          this.$emit('input', res.data.url)
        }
      }
    },
    // 上传图片前
    beforeUpload(file) {
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/bmp'
      if (!isJpgOrPng) {
        this.$message.error('只能上传jpj、png、bmp格式的图片!')
        return false
      }
      const maxSize = 5 * 1024 * 1024
      if (file.size > maxSize) {
        this.$message.error('图片大小补能超过5MB!')
        return false
      } else if (file.size > (2 * 1024 * 1024)) {
        return new Promise((resolve, reject) => {
          this.transformFile(file).then(res => {
            resolve(res)
          }).catch(error => {
            reject(error)
          })
        })
      } else {
        return true
      }
    },
    // 压缩转换上传的文件
    transformFile(file, maxSize = 2 * 1024 * 1024) {
      // const maxSize = 2 * 1024 * 1024
      return new Promise(resolve => {
        // 压缩
        // 先new一个img和fileReader的实例
        const img = new Image()
        const reader = new FileReader() // 读取文件资源
        reader.readAsDataURL(file)
        reader.onload = (e) => {
          img.src = e.target.result
          img.onload = () => {
            // 转化后的img元素后，先取出该元素的宽高度
            const { width, height } = img
            // 创建画布
            const canvas = document.createElement('canvas')
            const context = canvas.getContext('2d')
            // 设置宽高度为等同于要压缩图片的尺寸
            canvas.width = width
            canvas.height = height
            context.clearRect(0, 0, width, height)
            // 将img绘制到画布上
            context.drawImage(img, 0, 0, width, height)
            let cropImg = canvas.toDataURL('image/jpeg', 1.0)
            if (file.size > maxSize) {
              cropImg = canvas.toDataURL('image/jpeg', maxSize / file.size)
            }
            resolve(this.dataURLtoFile(cropImg, file.name))
          }
        }
      })
    },
    dataURLtoFile(dataurl, filename) {
      // 将base64转换为文件
      // console.log(dataurl)
      const arr = dataurl.split(',')
      const mime = arr[0].match(/:(.*?);/)[1]
      const bstr = atob(arr[1])
      let n = bstr.length
      const u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      // ！！！IE、Safari不支持使用new File()，File继承于Blob，绝大多数场景下，使用Blob对象就可以了
      return new File([u8arr], filename, { type: mime })
      // console.log(new Blob([u8arr], { type: mime }))
      // Blob 无法设置filename
      // const blob = new Blob([u8arr], { type: mime })
      // const file = new File([blob], new Date().getTime() + '.png')
      // return file
    }
  }
}
</script>
<style>
.avatar-uploader {
  width: auto;
}
.ant-upload.ant-upload-select-picture-card{
    margin-right: 0;
    margin-bottom: 0;
    width: 104px;
    height: 104px
}
.ant-upload.ant-upload-select-picture-card > .ant-upload{
  padding: 0
}
.avatar-uploader img {
    width: 102px;
    height: 102px;
}
</style>
